import { render, staticRenderFns } from "./GroupMemberDialog.vue?vue&type=template&id=3302ae4c&scoped=true"
import script from "./GroupMemberDialog.vue?vue&type=script&lang=js"
export * from "./GroupMemberDialog.vue?vue&type=script&lang=js"
import style0 from "./GroupMemberDialog.vue?vue&type=style&index=0&id=3302ae4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3302ae4c",
  null
  
)

export default component.exports